import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9650d94c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "grid"
};
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Id*", -1));
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Display name*", -1));
const _hoisted_6 = { class: "col-12" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Formatted name*", -1));
const _hoisted_8 = { class: "col-12" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "onedesk-input-label onedesk-input-label-linear" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Upload new icon (Only svg extension is supported)")
], -1));
const _hoisted_10 = { class: "user-edit-brand-button-wrapper" };
import { ref } from "vue";
import OneDeskInput from "@/components/atoms/OneDeskInput.vue";
import FileUpload from "primevue/fileupload";
import { updateBrand } from "@/repositories/brand.repository";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
import ImageWithNoImageDefault from "@/components/atoms/ImageWithNoImageDefault.vue";
import { mandatoryField } from "@/shared/utils/validation";
import useFormValidation from "@/shared/composables/useFormValidation";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpdateBrand',
    props: {
        "modelValue": { required: true },
        "modelModifiers": {},
    },
    emits: /*#__PURE__*/ _mergeModels(["brand-updated"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const { validationStateDict, invalidForm } = useFormValidation();
        const modelValue = _useModel(__props, "modelValue");
        const brand = ref({ ...modelValue.value });
        const blobUrl = ref("");
        const imgBase64 = ref(null);
        const notify = useToastNotify();
        const emit = __emit;
        const upload = (event) => {
            if (event.files && event.files[0]) {
                blobUrl.value = event.files[0].objectURL;
                const reader = new FileReader();
                reader.onload = (e) => imgBase64.value = e.target?.result;
                reader.readAsDataURL(event.files[0]);
            }
        };
        const onClear = () => {
            blobUrl.value = "";
            imgBase64.value = null;
        };
        const onSave = async () => {
            try {
                if (invalidForm.value) {
                    notify("", "Please enter the mandatory fields", "warn");
                }
                else {
                    const updatedBrand = buildUpdatedBrand();
                    await updateBrand(updatedBrand);
                    emit("brand-updated");
                    notify("", `Brand : ${brand.value.brandId} has been successfully updated`, "success");
                }
            }
            catch (error) {
                notify("", error.message, "error");
            }
        };
        const buildUpdatedBrand = () => {
            return {
                brandId: brand.value.brandId,
                displayBrand: brand.value.displayBrand,
                formattedBrand: brand.value.formattedBrand,
                base64Picture: imgBase64.value,
            };
        };
        return (_ctx, _cache) => {
            return (brand.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(OneDeskInput, {
                            modelValue: brand.value.brandId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((brand.value.brandId) = $event)),
                            "data-testid": "brand-id",
                            class: "wp-pages-inputs",
                            disabled: true,
                            rules: [_unref(mandatoryField)],
                            "onUpdate:valid": _cache[1] || (_cache[1] = ($event) => (_unref(validationStateDict).brandId = $event))
                        }, {
                            label: _withCtx(() => [
                                _hoisted_3
                            ]),
                            _: 1
                        }, 8, ["modelValue", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(OneDeskInput, {
                            modelValue: brand.value.displayBrand,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((brand.value.displayBrand) = $event)),
                            "data-testid": "display-brand",
                            class: "wp-pages-inputs",
                            rules: [_unref(mandatoryField)],
                            "onUpdate:valid": _cache[3] || (_cache[3] = ($event) => (_unref(validationStateDict).displayBrand = $event))
                        }, {
                            label: _withCtx(() => [
                                _hoisted_5
                            ]),
                            _: 1
                        }, 8, ["modelValue", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(OneDeskInput, {
                            modelValue: brand.value.formattedBrand,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((brand.value.formattedBrand) = $event)),
                            "data-testid": "formatted-brand",
                            class: "wp-pages-inputs",
                            rules: [_unref(mandatoryField)],
                            "onUpdate:valid": _cache[5] || (_cache[5] = ($event) => (_unref(validationStateDict).formattedBrand = $event))
                        }, {
                            label: _withCtx(() => [
                                _hoisted_7
                            ]),
                            _: 1
                        }, 8, ["modelValue", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode(ImageWithNoImageDefault, {
                            class: "mb-3",
                            "data-testid": "uploaded-icon",
                            source: modelValue.value?.pictureUri
                        }, null, 8, ["source"]),
                        _createVNode(_unref(FileUpload), {
                            "data-testid": "file-upload",
                            customUpload: true,
                            onSelect: upload,
                            onClear: onClear,
                            mode: "advanced",
                            accept: ".svg",
                            showCancelButton: true,
                            showUploadButton: false,
                            fileLimit: 1
                        }),
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(OneDeskButton, {
                                "data-testid": "save-button",
                                label: "Save",
                                disabled: _unref(invalidForm),
                                icon: "pi pi-save",
                                onClick: onSave
                            }, null, 8, ["disabled"])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
